/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */

class GmaoApplicationInfoController {


    /** @ngInject */
    constructor($log, applicationInfoService) {
        this.$log = $log;
        this.applicationInfoService = applicationInfoService;
        this.$log.debug('Controller \'GmaoApplicationInfo\' loaded');

    }

    $onInit() {
        this.applicationInfoService.findApplicationInfo().then(data => {
            this.applicationInfo = data.applicationInfo;
        });
    }

}
export const gmaoApplicationInfoComponent = {
        template: require('./gmao-application-info.html'),
        controller: GmaoApplicationInfoController,
        bindings: {
            model: '=',
            validationError: '<',
            disabled: '<',
            required: '<',
            placeholderKey: '<',
            hintKey: '<',
            labelNoFloat: '<'
        }
    };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoApplicationInfo.js